import React from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import SELVideo from 'assets/videos/deeper-learning-students.mp4';
import SELPoster from 'assets/img/deeper-learning-poster.png';
import DefiningSEL from 'assets/img/defining-sel.jpg';
import BenefitsOfSEL from 'assets/img/benefits-of-sel.jpg';
import DevelopingSocialEmotionalSkills from 'assets/img/developing-social-emotional-skills.jpg';
import SELForParentsCard from 'assets/img/sel-for-parents-card.jpg';
import SELForEducatorsCard from 'assets/img/sel-for-educators-card.jpg';
import SELForStudentsCard from 'assets/img/sel-for-students-card.jpg';
import styles from './styles.module.scss';

const WhatIsSEL = () => (
  <div className={styles.whatIsSEL}>
    <section className={`benefits-section ${styles.header} text-center`}>
      <div className={styles.contentWrapper}>
        <h3>About SEL and its Benefits</h3>
      </div>
    </section>

    <section className="benefits-section gray">
      <div className="container">
        <div className="row text-left">
          <div className="col-sm">
            <img src={DefiningSEL} />
          </div>
          <div className="col-sm">
            <h3>Core SEL Definition</h3>
            <p>Social-Emotional Learning (SEL) is the development of a set of core skills. <a href="https://casel.org/what-is-sel/">CASEL</a>, the leading research base for SEL, has broken these skills down into five core competencies:</p>
            <ul>
              <li>Self-awareness</li>
              <li>Self-management</li>
              <li>Social awareness</li>
              <li>Relationship skills</li>
              <li>Responsible decision-making</li>
            </ul>
            <p><strong>Bottom line:</strong> these are the core skills needed to apply academic and technical knowledge. We must develop these skills to be "future ready."</p>
          </div>
        </div>
      </div>
    </section>

    <section className="benefits-section white">
      <div className="container">
        <div className="row text-left">
          <div className="col-sm order-sm-2">
            <img src={BenefitsOfSEL} />
          </div>
          <div className="col-sm">
            <h3>Benefits of SEL</h3>
            <p>The learning environment and all the relationships within it are transformed!</p>
            <p>Educators see clear improvement in students' understanding and engagement with academic material and each other. Educators can also focus more on material and lessons while focusing less on behavioral and disciplinary issues.</p>
            <p>By developing core, evidence-based SEL skills, students are simply better prepared to apply their academic or technical knowledge. As an added bonus, they improve behavior, interactions with one another, and become more engaged in their education.</p>
            <p>Even outside of academic scenarios, students grow toward more positive social behaviors, a stronger sense of empathy and community, and are more effective team members.</p>
          </div>
        </div>
      </div>
    </section>

    <section className="benefits-section gray">
      <div className="container">
        <div className="row text-left">
          <div className="col-sm">
            <img src={DevelopingSocialEmotionalSkills} />
          </div>
          <div className="col-sm">
            <h3>Developing Social-Emotional Skills</h3>
            <p>These skills must be taught differently than traditional academic skills. Slideshows, videos, and reading text with discussion just aren't as effective because students don't get a chance to practice these skills and apply the SEL information. Not to mention, educators don't need <em>"one more thing"</em> to try to squeeze into their limited time with students.</p>
            <p>Social-Emotional skills are developed <strong>experientially</strong> - with practice and continuous opportunities to apply the skills. Students need to be placed in situations where they must communicate their ideas and understanding to their peers and resolve conflicts between themselves. In this way, students not only develop SEL skills through practice, but also build better relationships with their fellow students.</p>
          </div>
        </div>
      </div>
    </section>

    <section className="benefits-section white">
      <div className="container">
        <div className="row text-left">
          <div className="col-sm order-sm-2">
            <video src={SELVideo} poster={SELPoster} controls={true} />
          </div>
          <div className="col-sm">
            <h3>How Unyted SEL is Different</h3>
            <p>We go much further than simply showing students slides and videos to inform them on how these skills work. Or, self-reported surveys about typical academic situations or SEL climate in school. Unyted's direct integration of rigorous academic learning and SEL helps students develop both sets of skills without requiring their teacher to add "one more thing"to their lesson plan.</p>
            <p>Our unique, online activities allow students to learn academic standards in a fun, gamified way, while also putting them in situations to naturally develop social-emotional skills.</p>
            <p>During these activities, Unyted’s unique technology helps collect important social-emotional develop events in the students' performance and interactions with other students. Students, educators and administrators have all used this data to create continuous improvement.</p>
          </div>
        </div>
      </div>
    </section>

    <section className="benefits-section gray">
      <div className="container">
        <h3>Explore More</h3>
        <div className="row">
          <LinkContainer to="/sel-for/educators">
            <div className={`col-sm ${styles.linkCard}`}>
              <img src={SELForEducatorsCard} />
              <h4 className="text-center mt-3">SEL for Educators</h4>
            </div>
          </LinkContainer>
          <LinkContainer to="/sel-for/parents">
            <div className={`col-sm ${styles.linkCard}`}>
              <img src={SELForParentsCard} />
              <h4 className="text-center mt-3">SEL for Parents</h4>
            </div>
          </LinkContainer>
          <LinkContainer to="/sel-for/students">
            <div className={`col-sm ${styles.linkCard}`}>
              <img src={SELForStudentsCard} />
              <h4 className="text-center mt-3">SEL for Students</h4>
            </div>
          </LinkContainer>
        </div>
      </div>
    </section>
  </div>
);

export default WhatIsSEL;
